import { profileConstants } from '../_constants/userProfile.constants';
export function success(taskId) { return { type: profileConstants.PROFILE_SUCCESS, taskId } }
export function failure(error) { return { type: profileConstants.PROFILE_FAILURE, error } }